export function isBase64(str: string) {
  // Format yang diharapkan: data:image/png;base64, ...
  const base64Regex = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+)?;base64,([a-zA-Z0-9\\/+\n=]+)$/;

  return base64Regex.test(str);
}
